import React from "react";
import Trusted from "./Trusted";
import WorkTab from "./WorkTab";
import dashmock from "../assets/dashmock.png";
import dashmockup from "../assets/dashmockup.png";

const ShowOff = () => {
  return (
    <section className="pt-3">
      <Trusted />
      <div className="container">
        <WorkTab />
        <div
          className="dashmock position-relative p-3"
          data-aos="zoom-in-up"
          data-aos-anchor-placement="center-bottom">
          <img
            src={dashmockup}
            alt="dashboard mockup"
            data-aos="zoom-in-up"
            data-aos-duration="2000"
          />
        </div>
      </div>
    </section>
  );
};

export default ShowOff;
